import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import LandingPage from './components/LandingPage';
import VideoChat from './components/VideoChat';
import VideoChatRoom from './components/VideoChatRoom';
import HostStatus from './components/HostStatus';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import WidgetTest from './components/WidgetTest';
import LiveStreamTest from './components/LiveStreamTest';
import './App.css';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';

function App() {
  return (
    <AuthProvider>
      <Router basename={process.env.PUBLIC_URL || '/'}>
        <div className="App">
          <Switch>
            <Route exact path="/" component={LandingPage} />
            <Route path="/video-chat" component={VideoChatRoom} />
            <Route path="/login" component={Login} />
            <Route path="/widget-test" component={WidgetTest} />
            <Route path="/live-stream-test" component={LiveStreamTest} />
            <Route path="/privacy-policy" component={PrivacyPolicy} />
            <Route path="/terms-of-service" component={TermsOfService} />
            {/* Temporarily comment out dashboard route */}
            {/* <PrivateRoute path="/dashboard" component={Dashboard} /> */}
            <Route path="*">
              <Redirect to="/" />
            </Route>
          </Switch>
          <HostStatus />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App; 